interface Props {
  children: React.ReactNode;
  colorSwap?: boolean;
  disabled?: boolean;
  fit?: boolean;
  onClick?: () => void;
  red?: boolean;
  type?: 'button' | 'submit' | 'reset';
}

export default function BurnoutButton({ children, colorSwap, fit, onClick, red, type = 'submit', disabled }: Props) {
  if (colorSwap) {
    return (
      <button
        disabled={disabled}
        onClick={onClick}
        type={type}
        className={`bg-burnout-dark-gray hover:bg-burnout-light-gray ${fit ? 'w-fit' : 'w-full'} border-burnout-blue nice-hover-burnout hober:text-black cursor-pointer rounded-lg border-2 px-3 py-2 text-center font-bold text-white transition-all duration-200 ease-in-out`}
      >
        {children}
      </button>
    );
  }

  if (red) {
    return (
      <button
        disabled={disabled}
        onClick={onClick}
        type={type}
        className={`${fit ? 'w-fit' : 'w-full'} border-burnout-blue nice-hover-burnout bg-burnout-red hover:bg-burnout-light-red cursor-pointer rounded-lg border-2 px-3 py-2 text-center font-bold text-white transition-all duration-200 ease-in-out`}
      >
        {children}
      </button>
    );
  }

  return (
    <button
      disabled={disabled}
      onClick={onClick}
      className={`bg-burnout-light-gray hover:bg-burnout-dark-gray border-burnout-blue text-burnout-black nice-hover-burnout border-2 ${fit ? 'w-fit' : 'w-full'} cursor-pointer rounded-lg px-3 py-2 text-center font-bold transition-all duration-200 ease-in-out hover:text-white`}
    >
      {children}
    </button>
  );
}
